import { useQuery } from "@apollo/client";

import { COMPETITIONS } from "MVVM/GraphQL/competitions";
import { useUser } from "MVVM/Hooks/useUser";
import { TComp } from "MVVM/Views/Competitions/@types";

export const EnterCOTDWidgetViewModel = () => {
  const { allstarUser } = useUser();
  const { loading, data } = useQuery(COMPETITIONS, {
    variables: {
      activeOnly: true,
      mechanic: "COTD",
    },
    skip: !allstarUser?.user?._id,
    onError: () => {},
  });

  return {
    loading,
    data: data?.competitions[0] as TComp,
  };
};
